export function calculateBoundingBoxArea({ boundingBox }) {
  const minLon = boundingBox[0];
  const minLat = boundingBox[1];
  const maxLon = boundingBox[2];
  const maxLat = boundingBox[3];

  const latDiff = maxLat - minLat;
  const lngDiff = maxLon - minLon;

  return Math.abs(latDiff * lngDiff);
}

export function calculateZoomFromBoundingBoxArea(area) {
  let boxArea = Math.max(area, 4);

  const logArea = Math.abs(Math.log(boxArea));
  const multipliedArea = Math.min(logArea * 3, 18);

  const baseZoom = Math.floor(18 - multipliedArea);
  const limitedZoom = Math.min(Math.max(baseZoom, 2), 16);

  return limitedZoom;
}

export function calculateZoomFromBoundingBox({ boundingBox }) {
  const [west, south, east, north] = boundingBox;

  const boxCrosses180Meridian = west > east;

  const lngDiff = !boxCrosses180Meridian
    ? Math.abs(east - west)
    : Math.abs(360 - west + east);
  const latDiff = Math.abs(north - south);

  // Calculate the zoom level based on the longitude and latitude differences
  const lngZoom = Math.log2(360 / lngDiff);
  const latZoom = Math.log2(180 / latDiff);

  // Take the maximum zoom level between longitude and latitude zoom
  const zoomLevel = Math.floor(Math.max(lngZoom, latZoom));

  // Cap the zoom level between 2 and 18
  return Math.max(2, Math.min(zoomLevel, 18));
}
